/**
 * Import des styles et des modules
 * ****************************************
 */
import "./../scss/styles.scss";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import './modules/youtube-player';
import './modules/script';
import './modules/product';
import './modules/event-tracking';
import './modules/inline-video';
import './modules/modal';
import './modules/btns-shape';

import Sliders from './modules/Sliders';
import Cookies from './modules/cookies';

window.onload = () => {
    Sliders();
    Cookies();
};
